import {
  BySalesforceResourceMap,
  PartialSalesforceFieldMappingLocalData,
  SalesforceFieldMappingLocalData,
  SalesforceMappingOption,
} from 'module/api/integrations/salesforce/types';
import { PageLoading } from 'module/ui/components/atoms/loading';
import { memo } from 'react';
import { FieldsObject } from '../fields-object';
import { EmptyState } from './empty-state';
import { ResourceHeader } from './header';

export type ResourceMappingListType = {
  integrationId: number;
  resources: BySalesforceResourceMap;
  resourceMappingsStatus: 'error' | 'pending' | 'success';
  onObjectRemove: (resourceId: number) => void;
  onMappingAdd: (
    resourceId: number,
    externalField: SalesforceMappingOption<boolean> | null,
  ) => void;
  onMappingRemove: (
    resourceId: number,
    fieldMapping: SalesforceFieldMappingLocalData,
  ) => void;
  onMappingChange: (
    resourceId: number,
    mappingId: string,
    payload: PartialSalesforceFieldMappingLocalData,
  ) => void;
  showResourceModal: (value: boolean) => void;
};

export const ResourceMappingList = memo(
  ({
    integrationId,
    resourceMappingsStatus,
    resources,
    showResourceModal,
    onObjectRemove,
    onMappingAdd,
    onMappingRemove,
    onMappingChange,
  }: ResourceMappingListType) => {
    switch (resourceMappingsStatus) {
      case 'pending': {
        return (
          <div className="flex flex-col h-full min-h-0">
            <PageLoading />
          </div>
        );
      }

      case 'success': {
        const resourceList = Object.values(resources);

        if (resourceList?.length > 0) {
          return (
            <div className="flex flex-col h-full min-h-0">
              <div className="shrink-0">
                <ResourceHeader />
              </div>

              <div className="flex-1 min-h-0 overflow-y-auto">
                {Object.values(resources).map((fieldObject) => (
                  <FieldsObject
                    key={fieldObject.id}
                    onMappingAdd={onMappingAdd}
                    onMappingRemove={onMappingRemove}
                    onMappingChange={onMappingChange}
                    onObjectRemove={onObjectRemove}
                    fieldObject={fieldObject}
                    integrationId={Number(integrationId)}
                  />
                ))}
              </div>
            </div>
          );
        }

        return (
          <div className="flex flex-col h-full min-h-0">
            <EmptyState onResourceAdd={showResourceModal} />
          </div>
        );
      }

      case 'error':
      default: {
        return <div className="flex flex-col h-full min-h-0" />;
      }
    }
  },
);

ResourceMappingList.displayName = 'ResourceMappingList';
